import { writable } from "svelte/store";

const colorsModelsMap = writable([]);

export const getNewColorsMap = (models => {
  const newColorsMap = [];
  models.forEach((model, index) => {
    models.forEach((m, i) => {
      if (i == index) return;
      Object.keys(m).forEach(key => {
        if (model[key] && model[key] === m[key]) {
          if (!newColorsMap[index]) {
            newColorsMap[index] = {};
          }
          if (!newColorsMap[i]) {
            newColorsMap[i] = {};
          }

          newColorsMap[index][key] = '#dedede';
          newColorsMap[i][key] = '#dedede';
        }
      });
    });
  });
  return newColorsMap;
});

export default colorsModelsMap;